import { inTableFractionInput } from '@utils/component-framework';
import { NoSSR } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { TextInput } from '../write-answers.in-text/atom.text-input.js';
import { shouldHaveGroup, stateBox, container, fraction, readonlyFractionValue } from './input.fraction.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function InTableFractionInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => inTableFractionInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = (evt, target) => {
    update(props.taskEntryKey, props.input.id, {
      type: "in-table-fraction",
      denominator: "",
      number: "",
      numerator: "",
      ...inputEntry,
      [target]: evt.currentTarget.value ?? ""
    });
  };
  const state = useInputState(props.input, inputEntry);
  if (state !== "input") {
    const correctAnswer = props.input.validation.correctAnswers[0];
    return /*#__PURE__*/jsxs("span", {
      className: shouldHaveGroup,
      children: [/*#__PURE__*/jsx(StateBox, {
        state: state,
        className: stateBox,
        children: /*#__PURE__*/jsxs("div", {
          className: container,
          children: [inputEntry?.number, (inputEntry?.numerator || inputEntry?.denominator) && /*#__PURE__*/jsxs("div", {
            className: fraction,
            children: [/*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: inputEntry?.numerator
            }), /*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: inputEntry?.denominator
            })]
          })]
        })
      }), state === "incorrect" && /*#__PURE__*/jsx(StateBox, {
        state: "should-have",
        className: stateBox,
        children: /*#__PURE__*/jsxs("div", {
          className: container,
          children: [correctAnswer?.number, (correctAnswer?.numerator || correctAnswer?.denominator) && /*#__PURE__*/jsxs("div", {
            className: fraction,
            children: [/*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: correctAnswer?.numerator
            }), /*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: correctAnswer?.denominator
            })]
          })]
        })
      })]
    });
  } else {
    return /*#__PURE__*/jsx(NoSSR, {
      children: /*#__PURE__*/jsxs("div", {
        className: container,
        children: [/*#__PURE__*/jsx(TextInput, {
          value: inputEntry?.number,
          state: state,
          onChange: evt => onChange(evt, "number"),
          inputMode: "numeric"
        }), /*#__PURE__*/jsxs("div", {
          className: fraction,
          children: [/*#__PURE__*/jsx(TextInput, {
            value: inputEntry?.numerator,
            state: state,
            onChange: evt => onChange(evt, "numerator"),
            inputMode: "numeric"
          }), /*#__PURE__*/jsx(TextInput, {
            value: inputEntry?.denominator,
            state: state,
            onChange: evt => onChange(evt, "denominator"),
            inputMode: "numeric"
          })]
        })]
      })
    });
  }
}

export { InTableFractionInput };
//# sourceMappingURL=input.fraction.js.map
